module.exports = __webpack_public_path__ + "media/images/favicons/android-icon-36x36-6561bf16a85aa75ed44c84480bffbd7f.png";